import smartSolveApi from './instances/smartsolve';
import { CACHE_DB } from '../constants/indexedDB.constants';
import {
  getCacheDBValueByKey,
  setCacheDBValue,
  shouldSetCacheDBValue,
} from '../utils/indexedDB.cache.utils';

const {
  OBJECT_STORES: { ENTITY_DEFINITIONS },
  KEY_PATHS: { FORM_ENTITY_KEY },
} = CACHE_DB;

export const getEntityDefinition = async (
  entityType,
  certificationData,
  formSubEntityKey = '',
  itmId = ''
) => {
  try {
    const cacheKey = `${entityType} + ${localStorage.getItem('userCacheKey')}`;
    const cachedData = await getCacheDBValueByKey(ENTITY_DEFINITIONS, cacheKey);

    if (cachedData) {
      return cachedData.cache;
    }

    const response = await smartSolveApi.post('/getentitydefinition', {
      formEntityKey: entityType,
      certificationData,
      formSubEntityKey,
      itmId,
    });

    const lastModifiedDate = response.data.xsdModifiedDate;

    if (
      !response.data.hasError &&
      shouldSetCacheDBValue(ENTITY_DEFINITIONS, entityType, lastModifiedDate)
    ) {
      const entityDefinitionCacheDays = +localStorage.getItem('entityDefinitionCacheDays');
      const { entitySchema } = JSON.parse(localStorage.getItem('uiCacheObjects') || '{}');

      await setCacheDBValue(ENTITY_DEFINITIONS, {
        [FORM_ENTITY_KEY]: cacheKey,
        cache: response.data,
        modifiedDate: entitySchema[entityType],
        cacheExpirationDate: new Date(Date.now() + 1000 * 60 * 60 * 24 * entityDefinitionCacheDays),
      });
    }

    return response.data;
  } catch (e) {
    throw new Error(`getEntityDefinition() failed: ${e}`);
  }
};
